import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6B86211C-130B-4A90-A9C7-9B58A5228D30
 * name wind-turbine-check
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wind-turbine-check.svg
 * tags
 * - Home Automation 
 */
export const WindTurbineCheckIcon = createSvgIcon(<><path d="M11.33 11.67L14.21 14.58C15.62 13.16 14.21 11.75 14.21 11.75L12.72 10.24C12.9 9.86 13 9.44 13 9C13 7.95 12.46 7.03 11.64 6.5L13 2.11C11.09 1.53 10.5 3.44 10.5 3.44L9.69 6.03C8.46 6.16 7.46 7 7.13 8.18L2.67 9.63C3.31 11.53 5.2 10.9 5.2 10.9L7.27 10.23C7.61 10.97 8.23 11.54 9 11.82V19C9 19 7 19 7 21V22H13V21C13 21 13 19 11 19V11.82C11.12 11.78 11.23 11.72 11.33 11.67M8.5 9C8.5 8.17 9.17 7.5 10 7.5S11.5 8.17 11.5 9 10.83 10.5 10 10.5 8.5 9.83 8.5 9M16.75 21.16L14 18.16L15.16 17L16.75 18.59L20.34 15L21.5 16.41L16.75 21.16" /></>, 'WindTurbineCheckIcon');
export default WindTurbineCheckIcon